// src/features/customers/components/CustomerOrdersCard.tsx
import { GlassCard } from '../../../app/components/ui/GlassCard';
import { EmptyState } from '../../../app/components/foundation';

export type OrderStatus = 'completed' | 'pending' | 'cancelled';

export interface CustomerOrder {
  id: string;
  title: string;
  amount: string;
  status: OrderStatus;
  date: string;
}

/**
 * No customer-scoped (or representative-scoped) orders endpoint exists
 * on the backend today, and filtering a global orders list by customer
 * on the frontend isn't an option since no global orders endpoint was
 * provided either. Renders an explicit EmptyState instead — same
 * pattern already used by `CustomerOrdersSection` in the Customer
 * Workspace.
 *
 * `OrderStatus`/`CustomerOrder` stay exported since `CustomerOrderRow`
 * still depends on their shape for when a scoped endpoint lands.
 */
export function CustomerOrdersCard() {
  return (
    <GlassCard noPadding>
      <h2 className="px-5 pt-4 text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
        سفارش‌های اخیر
      </h2>

      <div className="mt-2 pb-2">
        <EmptyState message="فهرست سفارش‌های این مشتری پس از یکپارچه‌سازی با Core Orders در دسترس خواهد بود." />
      </div>
    </GlassCard>
  );
}
